// Notification sound generator using Web Audio API (no external files needed)
const AudioContext = window.AudioContext || window.webkitAudioContext;

const SOUNDS = {
  gentle_chime: {
    name: "Jemný zvonček",
    play: (ctx) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(1320, ctx.currentTime + 0.1);
      osc.frequency.exponentialRampToValueAtTime(880, ctx.currentTime + 0.2);
      gain.gain.setValueAtTime(0.3, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.5);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.5);
    },
  },
  double_ping: {
    name: "Dvojitý ping",
    play: (ctx) => {
      [0, 0.15].forEach((delay) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = "sine";
        osc.frequency.setValueAtTime(1200, ctx.currentTime + delay);
        gain.gain.setValueAtTime(0.25, ctx.currentTime + delay);
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + delay + 0.2);
        osc.start(ctx.currentTime + delay);
        osc.stop(ctx.currentTime + delay + 0.2);
      });
    },
  },
  soft_bell: {
    name: "Mäkký zvon",
    play: (ctx) => {
      const osc = ctx.createOscillator();
      const osc2 = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      osc2.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc2.type = "sine";
      osc.frequency.setValueAtTime(523, ctx.currentTime);
      osc2.frequency.setValueAtTime(659, ctx.currentTime);
      gain.gain.setValueAtTime(0.2, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.8);
      osc.start(ctx.currentTime);
      osc2.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.8);
      osc2.stop(ctx.currentTime + 0.8);
    },
  },
  urgent_beep: {
    name: "Urgentný bíp",
    play: (ctx) => {
      [0, 0.12, 0.24].forEach((delay) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = "square";
        osc.frequency.setValueAtTime(1000, ctx.currentTime + delay);
        gain.gain.setValueAtTime(0.15, ctx.currentTime + delay);
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + delay + 0.08);
        osc.start(ctx.currentTime + delay);
        osc.stop(ctx.currentTime + delay + 0.08);
      });
    },
  },
  rising_tone: {
    name: "Stúpajúci tón",
    play: (ctx) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.setValueAtTime(440, ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(880, ctx.currentTime + 0.3);
      osc.frequency.exponentialRampToValueAtTime(1320, ctx.currentTime + 0.5);
      gain.gain.setValueAtTime(0.25, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.6);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.6);
    },
  },
  none: {
    name: "Vypnuté",
    play: () => {},
  },
};

let audioCtx = null;

export const playNotificationSound = (soundId) => {
  if (!soundId || soundId === "none") return;
  const sound = SOUNDS[soundId];
  if (!sound) return;
  try {
    if (!audioCtx) audioCtx = new AudioContext();
    if (audioCtx.state === "suspended") audioCtx.resume();
    sound.play(audioCtx);
  } catch (e) {
    console.warn("Could not play notification sound:", e);
  }
};

export const NOTIFICATION_SOUNDS = Object.entries(SOUNDS).map(([id, s]) => ({
  id,
  name: s.name,
}));

export const getStoredSound = () => {
  try { return localStorage.getItem("trp_notif_sound") || "gentle_chime"; } catch { return "gentle_chime"; }
};

export const setStoredSound = (id) => {
  try { localStorage.setItem("trp_notif_sound", id); } catch {}
};
